import { InputEventType } from '../enums';

const InputEvents = {
  methods: {
    emitChange(value) {
      this.$emit(InputEventType.Change, value);
    },
    emitFocus(value) {
      this.$emit(InputEventType.Focus, value);
    },
    emitBlur(value) {
      this.$emit(InputEventType.Blur, value);
    },
    emitKeyDown(value) {
      this.$emit(InputEventType.Keydown, value);
    },
    emitKeyPress(value) {
      this.$emit(InputEventType.Keypress, value);
    },
    emitKeyUp(value) {
      this.$emit(InputEventType.Keyup, value);
    },
  },
};

export default InputEvents;
